import { API_SAVINGS_PLAN_MODAL_URL } from "src/constants/urls";
import { IQueryOptions } from "src/lib/tanstack-query/hooks/use-query";
import { useQuery } from "src/lib/tanstack-query/hooks/use-query";
import { ISavingsPlanData, ISavingsPlanDict } from "./invest.api";
import { tradeKeys } from "./trade.query-keys";

export interface ISavingsPlanResponse {
    data: ISavingsPlanData;
    dict: ISavingsPlanDict;
}

interface IRequest {
    wikifolioSecurityId: string;
    isin: string;
    wkn: string;
}

export function useSavingsPlanModalQuery({ wikifolioSecurityId, isin, wkn }: IRequest, options: IQueryOptions<ISavingsPlanResponse>) {
    return useQuery<ISavingsPlanResponse>({
        url: API_SAVINGS_PLAN_MODAL_URL,
        queryKey: tradeKeys.savingsPlan(wikifolioSecurityId, isin, wkn),
        queryParams: new URLSearchParams({ wikifolioSecurityId, isin, wkn }),
        ...options,
    });
}
